import CampaignTable from './CampaignTable';
import CampaignDetails from './CampaignDetails';
import RecentCampaignPerformance from './RecentCampaignPerformance';
import Statistics from './Statistics';
import WeeklyPerformance from './WeeklyPerformance';
import PushNotifications from './PushNotifications';
import PendingReceiptsBanner from './PendingReceiptsBanner';

export default {
  CampaignTable,
  CampaignDetails,
  RecentCampaignPerformance,
  Statistics,
  WeeklyPerformance,
  PushNotifications,
  PendingReceiptsBanner,
};
